export class Employer {
    employerName: string;
    startDate: Date;
    endDate: string;
    city: string;
    state: string;
    position: string;
    isCurrentEmployer: boolean;
    phone: string;
}